import { render } from "./ForgotPassword.vue?vue&type=template&id=7c564416&ts=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builderMaster/auth/infrastructure/component/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c564416"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c564416', __exports__)) {
    api.reload('7c564416', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=7c564416&ts=true", () => {
    api.rerender('7c564416', render)
  })

}


export default __exports__